import { useSelector, useDispatch } from "react-redux";
import Drawer from "@mui/material/Drawer";
import { TextField } from "@mui/material";

import CloseCross from "@/shared/components/CloseCross/CloseCross";
import ServicesHeaderSelector from "@/components/ServicesHeaderSelector/ServicesHeaderSelector";
import Title from "@/shared/components/Title/Title";
import useServices from "@/hooks/useServices";
import { RootState } from "@/store/store";
import { setToggleServiceDrawer } from "@/store/ui/ui";
import { inputStyles } from "@/utils/constants";
import {
    addServisesToNewAppointment,
    deleteServisesFromNewAppointment,
    addServisesToExsistAppointment,
    deleteServisesFromExistAppointment,
} from "@/store/appointments/appointmentsSlice";

import "./AppointmentsDrawerAddService.scss";

export default function AppointmentsDrawerAddService() {
    const dispatch = useDispatch();
    const { data, handleChange, query, category, handleChangeCategory } =
        useServices();
    const open = useSelector(
        (state: RootState) => state.ui.toggleServiceDrawer,
    );
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );

    const appointmentServices = useSelector((state: RootState) =>
        isEditAppointment
            ? state.appointments.existtAppointment.services
            : state.appointments.newAppointment.services,
    );
    const handleCheckboxChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        service: (typeof data)[number],
    ) => {
        const updatedService = {
            ...service,
            quantity: 1,
            discount: 0,
        };
        const { checked } = e.target;

        const addService = isEditAppointment
            ? addServisesToExsistAppointment
            : addServisesToNewAppointment;

        const removeService = isEditAppointment
            ? deleteServisesFromExistAppointment
            : deleteServisesFromNewAppointment;

        dispatch(
            checked ? addService(updatedService) : removeService(service._id),
        );
    };

    return (
        <Drawer
            open={open}
            onClose={() => dispatch(setToggleServiceDrawer(false))}
            anchor='right'
        >
            <div className='drawer_container'>
                <div className='drawer_title_container drawer_app_item'>
                    <Title tag='h2' text={"Додати послугу"} />
                    <CloseCross
                        onClick={() => dispatch(setToggleServiceDrawer(false))}
                    />
                </div>
                <TextField
                    type='text'
                    id='outlined-error-helper-text'
                    label='Введіть назву послуги'
                    variant='outlined'
                    sx={{ ...inputStyles.root, marginBottom: 2 }}
                    value={query}
                    onChange={handleChange}
                />
                <ServicesHeaderSelector
                    category={category}
                    handleChangeCategory={handleChangeCategory}
                />
                <ul className='drawer_listing_list'>
                    {data.map(service => (
                        <li
                            className='drawer_service_item'
                            key={service._id}
                            id={service._id}
                        >
                            <div className='custom-checkbox-container'>
                                <input
                                    type='checkbox'
                                    id={`checkbox-${service._id}`}
                                    className='custom-checkbox'
                                    onChange={e =>
                                        handleCheckboxChange(e, service)
                                    }
                                    checked={appointmentServices.some(
                                        item => item._id === service._id,
                                    )}
                                />
                                <label
                                    htmlFor={`checkbox-${service._id}`}
                                    className='custom-checkbox-label'
                                >
                                    <img
                                        src='/service-drawer/check.svg'
                                        alt='checkbox icon'
                                    />
                                </label>
                            </div>
                            <div className='drawer_services_title-container'>
                                <p>{service.title}</p>
                                <span>
                                    {service.price === "0"
                                        ? service.description
                                        : service.price}
                                </span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </Drawer>
    );
}
